require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./authors-perks-a-year-of-points-and-prizes.json") })
        }
      }, "path---authors-perks-a-year-of-points-and-prizes");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---authors-perks-a-year-of-points-and-prizes!./.cache/json/authors-perks-a-year-of-points-and-prizes.json
// module id = 1326
// module chunks = 231608221292675